import segmentPlugin from '@analytics/segment'
import Analytics from 'analytics'

import {
  AnalyticsAction,
  AnalyticsActionType,
  AnalyticsPageAction,
  AnalyticsTrackAction,
} from 'types/common/analytics.type'
import { excludeFalsy, isString } from 'utils/common'

export const analytics = Analytics({
  app: 'wpp-tccc-innovation-process',
  plugins: [
    segmentPlugin({
      writeKey: process.env.REACT_APP_SEGMENT_ANALYTICS_KEY,
    }),
  ].filter(excludeFalsy),
})

export const reset = () => {
  analytics.reset()
}

const getAnalyticsTenantAzId = () => analytics?.getState()?.user?.traits?.tenantAzId

const trackPage = ({ payload }: AnalyticsPageAction) => {
  const analyticsTenantAzId = getAnalyticsTenantAzId()
  if (analyticsTenantAzId) {
    analytics.page(
      {
        title: payload,
      },
      {
        agency: analyticsTenantAzId,
      },
    )
  }
}

const trackAction = ({ payload }: AnalyticsTrackAction) => {
  const analyticsTenantAzId = getAnalyticsTenantAzId()
  if (analyticsTenantAzId) {
    if (isString(payload)) {
      analytics.track(payload, {
        agency: analyticsTenantAzId,
      })
    } else {
      const { action, params } = payload

      analytics.track(action, {
        agency: analyticsTenantAzId,
        ...Object.fromEntries(params.map(({ key, value }) => [key, value])),
      })
    }
  }
}

export const trackAnalytics = (action: AnalyticsAction) => {
  switch (action.type) {
    case AnalyticsActionType.page:
      trackPage(action)
      break

    case AnalyticsActionType.action:
      trackAction(action)
      break

    default:
      break
  }
}

export const EVENTS = {
  INNOVATION_PAGE: 'pg_pv_innovation',

  INNOVATION_VIEW_VIDEO: 'pg_act_innovation_header_viewvideo',
  INNOVATION_VIEW_IDEA: 'pg_act_innovation_innovationprocess_viewidea',
  INNOVATION_VIEW_CONCEPT: 'pg_act_innovation_innovationprocess_viewconcept',
  INNOVATION_VIEW_SOLUTION: 'pg_act_innovation_innovationprocess_viewsolution',
  INNOVATION_VIEW_LAUNCHPREP: 'pg_act_innovation_innovationprocess_viewlaunchprep',
  INNOVATION_VIEW_MARKETEXECUTION: 'pg_act_innovation_innovationprocess_viewmarketexecution',
  INNOVATION_VIEW_SIMPLIFYFORGROWTH: 'pg_act_innovation_innovationprocess_viewsimplifyforgrowth',
  INNOVATION_INNOVATIONPROJECTS_LEARNMORE: 'pg_act_innovation_innovationprojects_liftandshift_learnmore',
  INNOVATION_CFP: { EXPAND: 'pg_act_innovation_cfp_expandcard', MINIMIZE: 'pg_act_innovation_cfp_minimizecard' },
  INNOVATION_OURSUCCESSES_VIEWCAROUSEL: (index: number) => `pg_act_innovation_oursuccesses_viewcarrousel${index}`,
  INNOVATION_CAROUSEL: { LEFT: 'pg_act_innovation_carouselleft', RIGHT: 'pg_act_innovation_carouselright' },
  INNOVATION_CFP_MARKETING_LEARNMORE: 'pg_act_innovation_cfp_marketing_learnmore',
  INNOVATION_CFP_TECHNICAL_LEARNMORE: 'pg_act_innovation_cfp_technicalinnovation_learnmore',
  INNOVATION_CFP_FINANCE_LEARNMORE: 'pg_act_innovation_cfp_finance_learnmore',
  INNOVATION_CFP_CUSTOMERCOMMERCIAL_LEARNMORE: 'pg_act_innovation_cfp_customercommercialleadership_learnmore',
  INNOVATION_VIEWMODAL: {
    EXPAND: (title: string, index: number) => `pg_act_innovation_innovationprocess_view${title}_expand${index}`,
    MINIMIZE: (title: string, index: number) => `pg_act_innovation_innovationprocess_view${title}_minimize${index}`,
  },
  INNOVATION_VIEWMODAL_SEEFULL: (title: string) => `pg_act_innovation_innovationprocess_view${title}_seefull`,
}
